import * as React from "react";
import Box from "@mui/material/Box";
import { Navigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AlignVerticalCenterTwoToneIcon from "@mui/icons-material/AlignVerticalCenterTwoTone";
import SettingsIcon from "@mui/icons-material/Settings";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import logo from "../../assets/images/logo.png";
import { useSelector } from "react-redux";
import { useState } from "react";

import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import SettingsPowerOutlinedIcon from "@mui/icons-material/SettingsPowerOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import LanguageIcon from "@mui/icons-material/Language";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import ContactsIcon from "@mui/icons-material/Contacts";
import { useLocation } from "react-router-dom";
import OPTIONS from "../../constant/Option";
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';

const commonStyleForListButton = {
  marginLeft: 2,
  width: "85%",
  marginRight: 5,
  my: 1,
  padding: 0.5,
  color: "#9A9A9A",
};

function ReturnMyCss(currentKey, yourKey) {
  return {
    marginLeft: 2,
    borderRadius: 1,
    width: "80%",
    marginRight: 5,
    my: 1,
    padding: 0.5,
    color: "#9A9A9A",
    bgcolor: currentKey == yourKey ? "#008F78" : "white", // Active green background
    color: currentKey == yourKey ? "white" : "#9A9A9A", // Active text color,
    "&:hover":
      currentKey === yourKey
        ? { bgcolor: "#008F78" } // No hover effect if active
        : {
            bgcolor: "#f5f5f5", // Hover background for inactive
            color: "#6D6D6D", // Hover text color for inactive
          },
  };
}

const commonStyleForIcon = {
  color: "#9A9A9A",
  marginLeft: 0.5,
};

const commonStyleFortextIncom = {
  marginLeft: -3,
};

const DrawerBox = (props) => {
  const [open, setOpen] = React.useState(false);
  const [profile, setProfile] = useState(false);
  const [myactivity, setMyactivity] = useState(false);
  const [otherActivity, setOtherActivity] = useState(false);
  const [payment, setPayment] = useState(false);
  const [accountSetting, setAccountSetting] = useState(false);
  const currentUser = useSelector((state) => state.astro.currentUser);
  const location = useLocation();

  // Extract the route key after "dashboard"
  const currentLocationKey = location.pathname.split("/")[2] || "";
  React.useEffect(() => {
    console.log("location", currentLocationKey);
  }, [currentLocationKey]);

  const handleClick = () => {
    setOpen(!open);
  };

  const navigate = useNavigate();

  const handleClickRoute = (e) => {
    navigate("/user");
  };
  return (
    <div>
      <Box
        sx={{
          width: "100%",
          minWidth: { xs: "280px", md: "150px" },
        }}
        role="presentation"
      >
        <img
          className="d-lg-none"
          src={logo}
          alt="logo"
          style={{ height: "68px", marginRight: "15px" }}
        />
        <List
          sx={{
            width: "100%",
            maxWidth: 300,
            bgcolor: "background.paper",

            m: 0,
            p: 0,
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <ListItemButton
            color="primary"
            sx={{
              ...ReturnMyCss(currentLocationKey, "home"),
            }}
            onClick={handleClick}
          >
            <ListItemIcon>
              <HomeIcon
                sx={{
                  ...commonStyleForIcon,
                  color: currentLocationKey == "home" ? "white" : "null",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              sx={{ ...commonStyleFortextIncom }}
              primaryTypographyProps={{ fontWeight: "500" }}
              onClick={(e) => {
                navigate("/dashboard/home");
              }}
            />
          </ListItemButton>
          
              <ListItemButton
                color="primary"
                sx={{
                  ...ReturnMyCss(currentLocationKey, "profile"),
                }}
                onClick={(e) => {
                  navigate("/dashboard/profile");
                }}
              >
                <ListItemIcon>
                  <ContactsIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "profile" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Profile"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>
  
       

          <ListItemButton
            color="primary"
            sx={{
              ...ReturnMyCss(currentLocationKey, "notification"),
            }}
            onClick={(e) => {
              navigate("/dashboard/notification");
            }}
          >
            <ListItemIcon>
              <NotificationsActiveOutlinedIcon
                sx={{
                  ...commonStyleForIcon,
                  color:
                    currentLocationKey == "notification" ? "white" : "null",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Notification"
              sx={{ ...commonStyleFortextIncom }}
              primaryTypographyProps={{ fontWeight: "500" }}
            />
          </ListItemButton>

          <ListItemButton
            color="primary"
            sx={{
              ...ReturnMyCss(currentLocationKey, "message"),
            }}
            onClick={(e) => {
              navigate("/dashboard/message");
            }}
          >
            <ListItemIcon>
              <ForumOutlinedIcon
                sx={{
                  ...commonStyleForIcon,
                  color: currentLocationKey == "message" ? "white" : "null",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Inbox"
              sx={{ ...commonStyleFortextIncom }}
              primaryTypographyProps={{ fontWeight: "500" }}
            />
          </ListItemButton>


          {
            OPTIONS.AccessLevel.employeeLevelAccess().includes(currentUser?.role)?<>  <ListItemButton
            color="primary"
            sx={{
              ...ReturnMyCss(currentLocationKey, "lead"),
            }}
            onClick={(e) => {
              navigate("/dashboard/lead");
            }}
          >
            <ListItemIcon>
              <NoteAddOutlinedIcon
                sx={{
                  ...commonStyleForIcon,
                  color: currentLocationKey == "lead" ? "white" : "null",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Lead Center"
              sx={{ ...commonStyleFortextIncom }}
              primaryTypographyProps={{ fontWeight: "500" }}
            />
          </ListItemButton></>:null
          }
        

          {currentUser?.role == "CLIENT" ? (
            <>
              {" "}
              <ListItemButton
                color="primary"
                sx={{
                  ...ReturnMyCss(currentLocationKey, "certificate"),
                }}
                onClick={(e) => {
                  navigate("/dashboard/certificate");
                }}
              >
                <ListItemIcon
                  sx={{
                    ...commonStyleForIcon,
                    color:
                      currentLocationKey == "certificate" ? "white" : "null",
                  }}
                >
                  <ContactsIcon color="#9A9A9A" />
                </ListItemIcon>
                <ListItemText
                  primary="Certificate"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>
            </>
          ) : null}

          {OPTIONS.AccessLevel.masterAdminLevelAccess().includes(
            currentUser.role
          ) ? (
            <>
              <ListItemButton
                color="primary"
                sx={{
                  ...ReturnMyCss(currentLocationKey, "finance"),
                }}
              >
                <ListItemIcon>
                  <AccountBalanceOutlinedIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "finance" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Finance"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>

              <ListItemButton
                color="primary"
                sx={{
                  ...ReturnMyCss(currentLocationKey, "user"),
                }}
                onClick={(e) => {
                  navigate("/dashboard/user");
                }}
              >
                <ListItemIcon>
                  <PeopleAltOutlinedIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "user" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="User"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>

              <ListItemButton
                color="primary"
                sx={{
                  ...ReturnMyCss(currentLocationKey, "report"),
                }}
                onClick={(e) => setAccountSetting(!accountSetting)}
              >
                <ListItemIcon>
                  <LeaderboardOutlinedIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "report" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Report"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>

              <ListItemButton
                color="primary"
                sx={{
                  ...commonStyleForListButton,
                  bgcolor:
                    currentLocationKey == "dataCenter" ? "#008F78" : "white", // Active green background
                  color:
                    currentLocationKey == "dataCenter" ? "white" : "#9A9A9A", // Active text color
                }}
              >
                <ListItemIcon>
                  <AddchartOutlinedIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "dataCenter" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Data Center"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>

              <ListItemButton
                color="primary"
                sx={{
                  ...commonStyleForListButton,
                  bgcolor:
                    currentLocationKey == "website" ? "#008F78" : "white", // Active green background
                  color: currentLocationKey == "website" ? "white" : "#9A9A9A", // Active text color
                }}
                onClick={(e) => {
                  navigate("/dashboard/help");
                }}
              >
                <ListItemIcon>
                  <LanguageIcon
                    sx={{
                      ...commonStyleForIcon,
                      color: currentLocationKey == "website" ? "white" : "null",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Website"
                  sx={{ ...commonStyleFortextIncom }}
                  primaryTypographyProps={{ fontWeight: "500" }}
                />
              </ListItemButton>
            </>
          ) : null}
        </List>
      </Box>
    </div>
  );
};

export default DrawerBox;
